import type { Factory } from 'walden-fast/types/mocks';
import type { Ticket, TicketStatus } from 'walden-fast/types/ticket';
import { selectRandom } from './lists';
import type {
  ContactSubmission,
  ContactSubmissionRequest,
  ContactValidationError,
} from 'walden-fast/types/fast-backend/contact';

const MOCK_TICKET: Ticket = {
  topic: 'shipment',
  title: 'Customer service contact topic',
  status: 'open',
  contact: 'person@movianto.com',
  date: new Date(1732721945000),
};

const TITLES = [
  'Shipping delays and tracking inquiries',
  'Returns and exchanges process',
  'Missing items in shipment',
  'Order cancellation requests',
  'Customer service contact topic',
  'International shipping options',
  'Customer feedback on delivery experience',
];

const TOPICS = [
  'Production Update',
  'Production Schedule',
  'Shipping Information',
  'Shipment Details',
  'Order Confirmation',
  'Production Overview',
];

const STATUSES: TicketStatus[] = ['open', 'closed'];

export const ticketFactory: Factory<Ticket> = (overrides) => ({
  ...MOCK_TICKET,
  title: selectRandom(TITLES),
  topics: selectRandom(TOPICS),
  status: selectRandom<TicketStatus>(STATUSES),
  date: new Date(1733750902000 + (Math.random() - 0.5) * 1000000000),
  ...overrides,
});

/**
 * Mock handler for support ticket submission with validation
 */
export function ticketSubmissionHandler(
  body: ContactSubmissionRequest,
): ContactSubmission | ContactValidationError {
  const errors: Record<string, string[]> = {};

  if (!body.topic || body.topic.trim() === '') {
    errors['Topic'] = ['The Topic field is required.'];
  }

  if (!body.subject || body.subject.trim() === '') {
    errors['Subject'] = ['The Subject field is required.'];
  }

  if (
    body.ticketType !== undefined &&
    (body.ticketType < 0 || body.ticketType > 1)
  ) {
    errors['TicketType'] = ['The field TicketType must be between 0 and 1.'];
  }

  if (!body.description || body.description.trim() === '') {
    errors['Description'] = ['The Description field is required.'];
  }

  if (Object.keys(errors).length > 0) {
    const validationError: ContactValidationError = {
      type: 'https://tools.ietf.org/html/rfc9110#section-15.5.1',
      title: 'One or more validation errors occurred.',
      status: 400,
      errors,
      traceId: `00-${Math.random().toString(16).substring(2, 34)}-${Math.random().toString(16).substring(2, 18)}-01`,
    };

    return validationError;
  }

  return {
    ticketId: '123',
  };
}
